var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3504 0.902039C15.2467 0.797545 15.1234 0.714606 14.9876 0.658006C14.8517 0.601406 14.706 0.572266 14.5588 0.572266C14.4117 0.572266 14.2659 0.601406 14.1301 0.658006C13.9942 0.714606 13.8709 0.797545 13.7673 0.902039L8.66121 6.0081C8.55757 6.11259 8.43427 6.19553 8.29841 6.25213C8.16256 6.30873 8.01684 6.33787 7.86966 6.33787C7.72249 6.33787 7.57677 6.30873 7.44091 6.25213C7.30506 6.19553 7.18175 6.11259 7.07811 6.0081L1.97205 0.902039C1.86841 0.797545 1.74511 0.714606 1.60925 0.658006C1.4734 0.601406 1.32768 0.572266 1.1805 0.572266C1.03333 0.572266 0.887609 0.601406 0.751753 0.658006C0.615897 0.714606 0.492592 0.797545 0.388951 0.902039C0.181307 1.11092 0.0647583 1.39349 0.0647583 1.68802C0.0647583 1.98255 0.181307 2.26511 0.388951 2.47399L5.50616 7.5912C6.13327 8.21753 6.98335 8.56934 7.86966 8.56934C8.75598 8.56934 9.60606 8.21753 10.2332 7.5912L15.3504 2.47399C15.558 2.26511 15.6746 1.98255 15.6746 1.68802C15.6746 1.39349 15.558 1.11092 15.3504 0.902039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.bd37a08c7eb289f8add3f2cb5e20d208.svg";
export { ForwardRef as ReactComponent };